import { Link } from 'react-router-dom';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import './NailCommissionPage.css';

export const AboutPage = () => {
    return (
        <PageLayout>
            <PageContainer>
                <PageBody>
                    <NavigationHeader />
                    <PageText>
                        <div className="about-landing">
                            <div className="about-header">
                                <img src={require("../images/site/tamagotchi-mametchi.gif")} alt="" className="about-gif" />
                                <h2 className="about-heading">egg tarty art studio</h2>
                                <img src={require("../images/site/kuchipatchi-spinning.gif")} alt="" className="about-gif" />
                            </div>

                            <div className="about-section">
                                <p className="about-text">hi, i'm joy ✧ welcome to my little corner of the internet.</p>
                                <p className="about-text">egg tarty art studio is a one-person shop where i make custom press-on nails, illustrations, stickers, and other cute things by hand.</p>
                                <p className="about-text">everything here is made with love, patience, and probably too much glue.</p>
                            </div>

                            <div className="about-section">
                                <span className="about-section-title">what i do</span>
                                <div className="about-offerings">
                                    <div className="about-offering">
                                        <span className="about-offering-label">✧ nails</span>
                                        <span className="about-offering-desc">custom press-on sets in almond, stiletto, or round. hand-painted designs, charms, and more.</span>
                                    </div>
                                    <div className="about-offering">
                                        <span className="about-offering-label">✧ art</span>
                                        <span className="about-offering-desc">digital illustrations and sticker designs. personalized to your vision.</span>
                                    </div>
                                    <div className="about-offering">
                                        <span className="about-offering-label">✧ extras</span>
                                        <span className="about-offering-desc">stickers, prints, crocheted items, and other handmade goodies in the shop.</span>
                                    </div>
                                </div>
                  
          </div>

                            <div className="about-section">
                                <span className="about-section-title">find me</span>
                                <div className="about-links">
                                    <a className="about-link" href="https://www.instagram.com/egg.tarty" target="_blank" rel="noopener noreferrer">
                                        @egg.tarty on instagram
                                    </a>
                                </div>
                            </div>

                            <div className="about-section">
                                <span className="about-section-title">quick links</span>
                                <div className="about-links">
                                    <Link to="/shop" className="about-link">shop →</Link>
                                    <Link to="/commissions" className="about-link">commissions →</Link>
                                </div>
                            </div>

                            <div className="about-footer-note">
                                <p>shipping to US only ✧ free shipping on orders over $50</p>
                            </div>
                        </div>
                    </PageText>
                    <PageFooter />
                </PageBody>
            </PageContainer>
        </PageLayout>
    );
};
